import React from 'react';

export default function CustomField(props) {
  const { label, id, type, placeholder, required, autoComplete, value, onChange } = props;

  return (
    <div className="FormRow">
      <label htmlFor={id} className="FormRowLabel">
        {label}
      </label>
      <input
        className="FormRowInput"
        id={id}
        type={type}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Payment/Components/CustomField.js